export default __webpack_public_path__ + "static/media/blue.1aefa5cb.png";